export default "__VITE_ASSET__CNVYCcya__"